import { Component, model} from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ThemeService } from '../../../../core/services/theme.service';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { OrganizationSwitcherComponent } from "../organization-switcher/organization-switcher.component";
import { BalancesPermission, ChartOfAccountsPermission, FeatureFlagPermission, FinancialsPermission, ImportPermission, MemberPermission, MessagePermission, OrganizationPermission, PaymentsPermission, PropertyPermission, SupportPermission, StripePermission, UserPermission } from '../../../../core/enums/permissions.enums';
import { IfHasPermissionDirective } from "../../../../core/directives/if-has-permission/if-has-permission.directive";
import { UserSessionService } from '../../../../core/services/user-session.service';
import { IsStaffDirective } from '../../../../core/directives/is-staff.directive';
import { DataEntityTypes } from '../../../../core/enums/data.enums';
import { StaffRoleConstants } from '../../../../core/constants/staff-roles.constants';
import { TooltipDirective, TooltipPlacement } from '../../../../core/directives/tooltip.directive';
import { OrganizationProfileNavItems } from '../../../../core/enums/nav-items.enum';
import { IfFeatureEnabledDirective } from "../../../../core/directives/if-feature-enabled/if-feature-enabled.directive";
import { FeatureFlag } from '../../../../core/enums/feature-flags.enums';

@Component({
  selector: 'ms-side-navigation',
  imports: [FontAwesomeModule, AsyncPipe, RouterLink, RouterLinkActive, OrganizationSwitcherComponent, IfHasPermissionDirective, IsStaffDirective, TooltipDirective, IfFeatureEnabledDirective],
  templateUrl: './side-navigation.component.html',
  styleUrl: './side-navigation.component.scss'
})
export class SideNavigationComponent {
  
  public isSidebarCollapsed = model<boolean>();

  public currentTheme$;
  public isDarkThemeActive$;

  public UserPermission = UserPermission;
  public FeatureFlagPermission = FeatureFlagPermission;

  // The union of the staff roles the Staff Management page can manage, matching its route guard:
  // anyone who may grant any one of them belongs on the page. Derived so adding a staff role does
  // not need this link updated too.
  public staffManagementPermissions = StaffRoleConstants.MANAGEABLE().map(manageable => manageable.permission);

  public OrganizationPermission = OrganizationPermission;
  public MemberPermission = MemberPermission;
  public BalancesPermission = BalancesPermission;
  public FinancialsPermission = FinancialsPermission;
  public ChartOfAccountsPermission = ChartOfAccountsPermission;
  public StripePermission = StripePermission;
  public PaymentsPermission = PaymentsPermission;
  public PropertyPermission = PropertyPermission;
  public ImportPermission = ImportPermission;
  public MessagePermission = MessagePermission;
  public SupportPermission = SupportPermission;
  public DataEntityTypes = DataEntityTypes;
  public OrganizationProfileNavItems = OrganizationProfileNavItems;
  public TooltipPlacement = TooltipPlacement;
  public FeatureFlag = FeatureFlag;

  constructor(private themeService: ThemeService, public userSessionService: UserSessionService) {
    this.currentTheme$ = this.themeService.currentTheme$;
    this.isDarkThemeActive$ = this.themeService.isDarkThemeActive$;
  }
}
